module.exports = __webpack_public_path__ + "static/media/3p_room.7a33cc04.svg";